











































































































import {Component, Vue} from "vue-property-decorator";
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import EForm from "@/components/datatable/EForm.vue";
import Number from "@/components/inputs/Number.vue";
import TextField from "@/components/inputs/TextField.vue";
import Id from "@/components/inputs/Id.vue";
import CategoryAdditionalListing2 from "@/components/inputs/CategoryAdditionalListing2.vue";
import CategoriesSelect from "@/components/inputs/CategoriesSelect.vue";
import ImageUpload from "@/components/inputs/ImageUpload.vue";
import UrlCopy from "@/components/inputs/UrlCopy.vue";
import Seo from "@/components/inputs/Seo.vue";
import EnabledSwitch from "@/components/inputs/EnabledSwitch.vue";
import LetEditable from "@/components/LetEditable.vue";
import {ActionsEnum} from "@/entity/ActionsEnum";
import {categories} from "@/entity/CategoryEntity";
import CategoryListingEntity from "@/entity/CategoryListingEntity";
import ImageShow from "@/components/ImageShow.vue";

@Component({
    components: {
        ImageShow,
        DeleteButton,EForm,Number,TextField,Id,CategoryAdditionalListing2,CategoriesSelect,ImageUpload,Seo,UrlCopy,EnabledSwitch,LetEditable
    }
})

export default class Category extends  Vue{
    items : categories[] = [];
    categories : categories[] = [];
    categoryListing : CategoryListingEntity[] = [];
    dialog = false;
    title:string = "";
    search: string = "";
    baseAction:string = ActionsEnum.Categories;
    action:string = this.baseAction;
    data : categories = new categories();
    enabled:any=0;
    headers = [
        {
            text: "Id",
            align: "start",
            sortable: true,
            value: "cat_id"
        },
        {text: "Resim", value: "thumb_image_url"},
        {text: "Üst kategori", value: "parent_cat_name"},
        {text: "Başlık", value: "title"},
        {text: "Açıklama", value: "description"},
        {text: "Ek listeleme",value: "additionalListing"},
        {text: "Sıra",value: "no"},
        {text: "İşlemler", value: "actions"},
    ];
    async edit(item:categories){
        if(this.data.parent_id == null){
            this.enabled = 1;
        }else{
            this.enabled = 0;
        }
        this.title = "Düzenle";
        this.data = item;
        this.action = this.baseAction + "/" + item.cat_id;
        this.dialog = true;
        let response = await this.$http.get("categoryAdditionalListing/" + this.data.cat_id);
        this.categoryListing = response.data;

    }
    add(){
        this.title = "Ekle";
        this.action = this.baseAction;
        this.data = new categories();
        this.dialog = true;
    }
    success(insertResponse:categories){
        this.get();
        this.edit(insertResponse);
        this.dialog = false;
    }
    async get(){
        let response = await this.$http.get(this.baseAction);
        this.items = response.data;
        this.items.forEach((item) =>{
            item.parent_cat_name = this.parentCatType(item);
        });
        this.categories = [];
        this.recursiveCatFilter(null);

    }

    recursiveCatFilter(parentId : any){
        let cats = this.items.filter(x=>x.parent_id == parentId);
        cats.forEach(item=>{
            this.categories.push(item);
            this.recursiveCatFilter(item.cat_id);
        })
    }

    created(){
        this.get();
    }
    itemRowBackground(item:categories){
        return item.parent_id == null ? 'primary' : 'default'
    }
    editParent(item:categories){
        let cat = this.items?.find(x=>x.cat_id == item.parent_id);
        if(cat){
            this.edit(cat);
        }else{
            return;
        }
    }
    parentCatType(item : categories){
        if(item.parent_id == null){
            return "Ana kategori";
        }else{
            let cat = this.items?.find(x=>x.cat_id == item.parent_id);
            if(cat){
                return cat.title;
            }
        }
        return "";
    }
    changeSwitch(){
        if(this.enabled == 1){
            this.data.parent_id = null;
        }
    }
};
